import React, { useMemo } from 'react';
import * as styles from './Badge.module.scss';
import Tooltip from '@components/Tooltip';
import classNames from 'classnames';
import { uniqueId } from 'lodash';
import QuestionIcon from './question-icon.svg';

export default function Badge({
  id,
  className,
  badgeName,
  badgeStyle,
  tooltip,
  hideTooltip,
  minTooltipLeftOffset,
  maxTooltipRightOffset,
  tooltipMaxWidth,
  tooltipContainer,
  children
}) {
  const contentId = useMemo(() => {
    return id ?? uniqueId('badge-content-');
  }, [id]);

  const hasTooltip = !!tooltip && !hideTooltip;

  const badgeStyleClassName =
    badgeStyle && badgeStyle !== 'default' ? `mp-badge-${badgeStyle}` : null;

  return (
    <div
      data-badge={badgeName}
      className={classNames(
        'mp-badge',
        badgeStyleClassName,
        styles.badge,
        className,
        {
          [styles.hasTooltip]: hasTooltip
        }
      )}
    >
      <Tooltip
        contentId={contentId}
        text={tooltip}
        forceHidden={hideTooltip}
        minLeftOffset={minTooltipLeftOffset}
        maxRightOffset={maxTooltipRightOffset}
        maxWidth={tooltipMaxWidth}
        container={tooltipContainer}
        isInfoPopover
      >
        <div id={contentId} className={styles.badgeContent}>
          {children}
          {hasTooltip && (
            <div className={styles.tooltipIcon}>
              <QuestionIcon />
            </div>
          )}
        </div>
      </Tooltip>
    </div>
  );
}
